module.exports = __webpack_public_path__ + "static/media/a.71774156.jpg";